module.exports = __webpack_public_path__ + "img/logo2.3cfee06a.png";